import { WorkspaceGraph } from "./graph.js";
import { UserWorkspaceGraph } from "./userGraph.js";
export function workspaceGraph(workspaces, projects, teams) {
    return new WorkspaceGraph({ workspaces, projects, teams });
}
export function userWorkspaceGraph(workspaces, projects, teams, users) {
    return new UserWorkspaceGraph({ workspaces, projects, teams, users });
}
//# sourceMappingURL=create.js.map